import React, { useState } from 'react';
import { Button, Card, CardBody, Collapse, Spinner } from 'reactstrap';
import infoCircle from '../assets/info-circle.svg';
import FormToast from '../../Form/Toast';

/**
 * Escrow Smart Contract component
 * 
 * Renders Contract total in Crypto, USD/Crypto exchange rate, date and source
 */
export function EscrowSmartContract({ solution, loading, error }) {
    const [isDetailsOpen, setIsDetailsOpen] = useState(false);

    const toggleDetails = () => setIsDetailsOpen(!isDetailsOpen);
    const reloadComponent = () => window.location.reload();

    const totalBudgetBlockChain = solution?.escrowSmartContract?.totalBudget;
    const currencyCodeBlockChain = solution?.escrowSmartContract?.currency?.code;
    const currencyCodeFrom = solution?.escrowSmartContract?.currencyFrom?.code;
    const exchangeRate = solution?.escrowSmartContract?.currencyRate?.toFixed(6);
    const rateTime = new Date(solution?.escrowSmartContract?.currencyRateTime);

    return (
        <>
            {
                solution &&
                <>
                    <div className='row'>
                        <div className='col'>
                            Total budget
                        </div>
                        <div className='col' role='button' onClick={toggleDetails}>
                            <span className='fw-bold align-middle'>
                                {
                                    `${totalBudgetBlockChain} ${currencyCodeBlockChain}`
                                }
                            </span>
                            {' '}
                            {
                                !isDetailsOpen &&
                                <img alt='' src={infoCircle}/>
                            }
                            {
                                isDetailsOpen &&
                                <i className="arrow up align-middle mt-1 ms-2"/>
                            }
                        </div>
                    </div>
                    <div className='row w-100'>
                        <Collapse isOpen={isDetailsOpen}>
                            <Card>
                                <CardBody>
                                    <div className='row'>
                                        <div className='col-sm-6 col-5'>
                                            Exchange Rate
                                        </div>
                                        <div className='col-sm-6 col-7 text-end'>
                                            <span className='fw-bold'>
                                                {`${exchangeRate} ${currencyCodeBlockChain}/${currencyCodeFrom}`}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-sm-6 col-5'>
                                            Exchange Date
                                        </div>
                                        <div className='col-sm-6 col-7 text-end'>
                                            <span className='fw-bold'>
                                                {rateTime?.toLocaleString()}
                                            </span>
                                        </div>
                                    </div>
                                    <br />
                                    <div className='row'>
                                        <div className='col-12'>
                                            Source
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <span className='fw-bold'>
                                                <a href={solution?.escrowSmartContract?.currencyRateSource}>
                                                    {solution?.escrowSmartContract?.currencyRateSource}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Collapse>
                    </div>
                </>
            }
            {
                loading &&
                <>
                    <Spinner className='contract-info-loading' size="sm" />
                    {" "}
                    <span>Loading contract info, please wait...</span>
                </>

            }
            {
                error &&
                <>
                    <div className='row'>
                        <div className='col-sm-12 ps-0'>
                            <FormToast
                                show={true}
                                message={
                                    <span>
                                        Failed loading contract info. Please
                                        <Button
                                            className='text-light ms-3 link-button'
                                            onClick={reloadComponent}
                                        >
                                            Try again
                                        </Button>
                                    </span>
                                }
                                className="bg-danger"
                            />
                        </div>
                    </div>
                </>
            }
        </>
    )
}